declare global {
  interface Window {
    posthog: { identify: (email: string) => void };
  }
}

window.posthog = window.posthog || {};
window.posthog.identify = window.posthog.identify
  ? window.posthog.identify.bind(window.posthog)
  : () => {};

export const posthog = window.posthog;
